import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { guestIntakeConvertPath, GuestConvertRole } from "../../constants/guestIntake";
import { GUEST_CONVERSION_EVENT } from "../../constants/guestRestrictions";
import { RootState } from "../../store/store";
import { GuestRoleConversionModal } from "./GuestRoleConversionModal";

export function GuestConversionModalHost() {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.user.user);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const openModal = () => setVisible(true);
    window.addEventListener(GUEST_CONVERSION_EVENT, openModal);
    return () => window.removeEventListener(GUEST_CONVERSION_EVENT, openModal);
  }, []);

  const handleSelectRole = (role: GuestConvertRole) => {
    navigate(guestIntakeConvertPath({ role }));
  };

  return (
    <GuestRoleConversionModal
      visible={visible}
      expired={Boolean(user?.guestExpired)}
      onClose={() => setVisible(false)}
      onSelectRole={handleSelectRole}
    />
  );
}
